/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: { input: any; output: any; }
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: { input: any; output: any; }
  /** Can be used as an argument to upload files using https://github.com/jaydenseric/graphql-multipart-request-spec */
  Upload: { input: any; output: any; }
};

/**  game information  */
export type GameInfo = {
  __typename?: 'GameInfo';
  /**  game id  */
  gameId: Scalars['String']['output'];
  /**  ID  */
  id: Scalars['ID']['output'];
  /**  name  */
  name: Scalars['String']['output'];
  /**  order  */
  order: Scalars['Int']['output'];
  /**  picture relative path  */
  picturePath: Scalars['String']['output'];
  /**  platform code  */
  platformCode: PlatformCodeEnum;
  /**  game type  */
  type: GameTypeEnum;
};

export type GameInfoInput = {
  /**  game id  */
  gameId?: InputMaybe<Scalars['String']['input']>;
  /**  platform code  */
  platformCode?: InputMaybe<PlatformCodeEnum>;
  /**  game type  */
  type?: InputMaybe<GameTypeEnum>;
};

/** A paginated list of GameInfo items. */
export type GameInfoPaginator = {
  __typename?: 'GameInfoPaginator';
  /** A list of GameInfo items. */
  data: Array<GameInfo>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Game type enum */
export enum GameTypeEnum {
  /** ARCADE */
  Arcade = 'ARCADE',
  /** CASINO */
  Casino = 'CASINO',
  /** FISH */
  Fish = 'FISH',
  /** LIVE */
  Live = 'LIVE',
  /** SLOT */
  Slot = 'SLOT',
  /** TABLE */
  Table = 'TABLE'
}

export type LaunchGameInput = {
  /**  game id  */
  gameId: Scalars['String']['input'];
  /**  platform code  */
  platformCode: PlatformCodeEnum;
};

export type LaunchGameResult = {
  __typename?: 'LaunchGameResult';
  /**  是否成功  */
  success: Scalars['Boolean']['output'];
  /**  启动网址  */
  url: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**  launch game  */
  launchGame?: Maybe<LaunchGameResult>;
};


export type MutationLaunchGameArgs = {
  input: LaunchGameInput;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

/** Platform code enum */
export enum PlatformCodeEnum {
  /** ACEWIN_SW */
  AcewinSw = 'ACEWIN_SW',
  /** ACEWIN_US_SW */
  AcewinUsSw = 'ACEWIN_US_SW',
  /** COMBO_SW */
  ComboSw = 'COMBO_SW',
  /** FC_SINGLE_WALLET */
  FcSingleWallet = 'FC_SINGLE_WALLET',
  /** GAME_CONVERGE_SW */
  GameConvergeSw = 'GAME_CONVERGE_SW',
  /** GC_FB */
  GcFb = 'GC_FB',
  /** GC_SINGLE_WALLET */
  GcSingleWallet = 'GC_SINGLE_WALLET',
  /** GO_WIN_SW */
  GoWinSw = 'GO_WIN_SW',
  /** JDB_SW_A */
  JdbSwA = 'JDB_SW_A',
  /** LUCKY_SPORTS_SW */
  LuckySportsSw = 'LUCKY_SPORTS_SW',
  /** PG_SW_A */
  PgSwA = 'PG_SW_A',
  /** PINNACLE_SW_A */
  PinnacleSwA = 'PINNACLE_SW_A',
  /** PLAY8_SW_A */
  Play8SwA = 'PLAY8_SW_A',
  /** PP_SW_A */
  PpSwA = 'PP_SW_A',
  /** SEXYBCRT_SW_A */
  SexybcrtSwA = 'SEXYBCRT_SW_A'
}

export type Query = {
  __typename?: 'Query';
  /**  game information  */
  gameInfos: GameInfoPaginator;
  ping: Scalars['String']['output'];
};


export type QueryGameInfosArgs = {
  first?: Scalars['Int']['input'];
  input?: InputMaybe<GameInfoInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type LaunchGameMutationVariables = Exact<{
  input: LaunchGameInput;
}>;


export type LaunchGameMutation = { __typename?: 'Mutation', launchGame?: { __typename?: 'LaunchGameResult', success: boolean, url: string } | null };

export type HQueryVariables = Exact<{
  input?: InputMaybe<GameInfoInput>;
}>;


export type HQuery = { __typename?: 'Query', gameInfos: { __typename?: 'GameInfoPaginator', paginatorInfo: { __typename?: 'PaginatorInfo', count: number, currentPage: number, firstItem?: number | null, hasMorePages: boolean, lastItem?: number | null, lastPage: number, perPage: number, total: number }, data: Array<{ __typename?: 'GameInfo', id: string, platformCode: PlatformCodeEnum, type: GameTypeEnum, name: string, gameId: string, picturePath: string, order: number }> } };


export const LaunchGameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"launchGame"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LaunchGameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"launchGame"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<LaunchGameMutation, LaunchGameMutationVariables>;
export const HDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"H"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GameInfoInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gameInfos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paginatorInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"currentPage"}},{"kind":"Field","name":{"kind":"Name","value":"firstItem"}},{"kind":"Field","name":{"kind":"Name","value":"hasMorePages"}},{"kind":"Field","name":{"kind":"Name","value":"lastItem"}},{"kind":"Field","name":{"kind":"Name","value":"lastPage"}},{"kind":"Field","name":{"kind":"Name","value":"perPage"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"platformCode"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gameId"}},{"kind":"Field","name":{"kind":"Name","value":"picturePath"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]}}]} as unknown as DocumentNode<HQuery, HQueryVariables>;